import API from '..';

const auth = (data) => API.post('/api/v1/auth/', data);

export default auth;
